import { Edit, MoreVert } from "@mui/icons-material";
import { Checkbox, IconButton, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import MenuConfigStandard from "../../../../components/MenuStyled/MenuConfigStandard";
import { useTranslation } from "react-i18next";
import { ValidationRuleVOActivity } from "../../../../model/ValidationRuleModel";

interface IValidationRuleTableBody {
    activity: ValidationRuleVOActivity[];
    handleMenuOpen: (e: any, vr: ValidationRuleVOActivity) => void;
    setRowsSelected: (set: number[]) => void;
    rowsSelected: number[];
    handleMenuClose: () => void;
    anchorEl: HTMLElement;
    onClickEdit: (input: ValidationRuleVOActivity) => void;
    selectedVr: ValidationRuleVOActivity;
}

export const ValidationRuleTableBody: React.FC<IValidationRuleTableBody> = ({
    activity,
    handleMenuOpen,
    setRowsSelected,
    rowsSelected,
    handleMenuClose,
    anchorEl,
    onClickEdit,
    selectedVr
}) => {

    const { t } = useTranslation();

    return (
        <TableBody>
            {activity.map((vr, index) => (
                <>
                    <TableRow 
                        key={vr.id}
                        sx={{ 
                                '&:hover': { 
                                bgcolor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                    >
                        <TableCell sx={{ p: 1, borderBottom: 'none', display: "flex" }}>
                            <IconButton 
                                aria-label="more" 
                                onClick={(e) => handleMenuOpen(e, vr)}
                                size="small"
                            >
                                <MoreVert fontSize="small" />
                            </IconButton>
                            <Checkbox 
                                value={vr.id}
                                size='small'
                                onChange={(e, checked) => {
                                    if (checked) {
                                        setRowsSelected([...rowsSelected, Number(vr.id)]);
                                    } else {
                                        let arrayFilter = rowsSelected.filter(row => row != vr.id!);
                                        setRowsSelected(arrayFilter);
                                    }
                                }}
                            />
                        </TableCell>
                        <TableCell sx={{ py: 2, borderBottom: 'none' }}>
                            <Typography variant="body1" sx={{ color: '#333' }}>
                                {vr.name}
                            </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 2, borderBottom: 'none' }}>
                            <Typography variant="body2" sx={{ color: '#666' }}>
                                {vr.responsability?.map((name, index, list) => {
                                    if (index == list.length - 1) {
                                        return name.nameObject
                                    } else {
                                        return name.nameObject + ", "
                                    }
                                })}
                            </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 2, borderBottom: 'none' }}>
                            <Typography variant="body2" sx={{ color: '#666' }}>
                                {vr.term}
                            </Typography>
                        </TableCell>
                        <MenuConfigStandard 
                            anchorEl={anchorEl!}
                            handleMenuClose={handleMenuClose}
                            listMenu={[
                                {
                                    icon: <Edit />,
                                    method: () => onClickEdit(selectedVr),
                                    text: t("ValidationRule.EditInformation")
                                },
                            ]}
                        />
                    </TableRow>
                </>
                
            ))}
        </TableBody>
    )
}